const state = {
    cycle: {
        version: {
            status: {}
        }
    }
}

const actions = {
    setCycle (context, data) {
        context.commit("setCycle", data)
    },
    fetchSections (context) {
        axios.get("api/sections?version_id="+ context.state.cycle.version.id)
        .then( (response) => {
            context.commit("setSections", response.data.data)
        })
        .catch( (e) => {
            console.log("Error: cycle.js, fetchSections()"+ e.message)          
        })
    },
    fetchIndicators (context, state) {
        axios.get("api/indicators?version_id="+ context.state.cycle.version.id)
        .then( (response) => {
            context.commit("setIndicators", response.data)
        })
        .catch( (e) => {
            console.log("Error: cycle.js, fetchIndicators()"+ e.message)          
        })
    }
}

const mutations = {
    setCycle (state, data) {
        return state.cycle = data
    },
    setSections (state, data) {
        return state.sections = data
    },
    setIndicators (state, data) {
        return state.indicators = data
    }
}

const getters = {
    //
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}